import React from 'react';
import { Button } from '@noths/polaris-design-system-core-components';

import * as styles from './InspirationCard.styles';

export interface InspirationCardImage {
  src: string;
  width: number;
}

export interface InspirationCardProps {
  description?: string;
  href: string;
  images: InspirationCardImage[];
  lazyImage?: boolean;
  title: string;
}

// A card spans the full width of a phone and about a quarter of the widest grid.
const IMAGE_SIZES = '(min-width: 768px) 25vw, 100vw';

export const InspirationCard = ({
  description,
  href,
  images,
  lazyImage = true,
  title,
}: InspirationCardProps) => (
  <article css={styles.card}>
    <div css={styles.media}>
      {images.length > 0 && (
        <img
          alt=""
          css={styles.image}
          loading={lazyImage ? 'lazy' : undefined}
          sizes={IMAGE_SIZES}
          src={images[0]!.src}
          srcSet={images.map(({ src, width }) => `${src} ${width}w`).join(', ')}
        />
      )}
    </div>
    <div css={styles.body}>
      <h3 css={styles.title}>
        <a css={styles.titleLink} href={href}>
          {title}
        </a>
      </h3>
      {description && <p css={styles.description}>{description}</p>}
      {/* Visual only: the title link already covers the whole card, so this would
          be a second tab stop and a duplicate link for screen readers. */}
      <span aria-hidden css={styles.action}>
        <Button compact href={href} tabIndex={-1}>
          Read more
        </Button>
      </span>
    </div>
  </article>
);
